
import '../App.css';
import { Container, Title, Card, Text, Space, Divider } from '@mantine/core';
import Footer from '../components/Footer';
import Head from '../components/Head';
import ReactMarkdown from 'react-markdown';

// DATA: The Official Rules split by category for better readability
const rulesSections = [
    {
        id: 'top-comic',
        title: "Top Comic (Global and Local leaderboards)",
        content: `
### 1. HOW TO ENTER
Beginning on January 1st, 2026 through December 15, 2026 (the “Promotion Period”), log-in to the Comedy Seen app using your Comedian account, and begin adding and/or checking-in to events.

### 2. ELIGIBILITY
Open to residents of states and countries where the app is available and 18 years of age and older as of January 1st, 2026. Void in countries where the app is not available and where otherwise prohibited. Comedian must have less than 1.25M followers on any combined social media platforms during the Promotion Period to be eligible. Comedians must be active during the year.

### 3. LIMITATION OF LIABILITY
By entering this promotion, entrants waive all right to, and hold Pobblebonk, LLC harmless from, any claim, liability, loss, damage (including punitive, incidental, and consequential damages), or expense (including attorneys' fees) arising out of or in connection with participation in this promotion or the acceptance, use, or misuse of any prize.

### 4. WINNER SELECTION
Winners for both World’s Top Comic and Top Comic - local will be determined as follows:

* (a) Each registered check-in during the Promotion Period by an individual Comedian will be counted as one Point.
* (b) Each registered check-in during the Promotion Period by an individual Comedian that is validated by a comedian or fan of the event that is checked into will count as one Point.
* (c) Each registered check-in during the Promotion Period by an individual Comedian that results in an “upvote” from a Fan will count as three Points.
* (d) Each registered check-in during the Promotion Period by an individual Comedian that results in an “upvote” from a New Fan will count as ten Points. A New Fan is a fan that hasn’t upvoted the comedian before.
* (e) Each validated showcase that is submitted (that is not part of a festival) will be counted as one Point.
* (f) Each validated Open Mic that is submitted will be counted as two Points.
* (g) Each validated dead Open Mic an individual comedian reports as being dead will be counted as three Points.
* (h) Each valid and unique bug report will be counted as ten points.
* (i) In the event of a tie, the winner will be determined by lifetime points accumulated on the app first, and duration of their account second.
* (j) Pobblebonk, LLC reserves the right to disqualify any entrant found to be tampering with the entry process, using automated scripts/bots, or violating the Term of Service.

### 5. PRIZES

**Top Comic in the World:**
* **1st Place:** $500.00 cash prize
* **2nd Place:** $200.00 cash prize
* **3rd Place:** $100.00 cash prize

**Top Comic (local):**
The prizes for this will be announced as they are created. All prizes and rules are subject to be changed at the discretion of the founder of Pobblebonk, LLC.

### 6. CHOICE OF LAW, FORUM, TERMS, AND PRIVACY
Entrant agrees that all matters arising out of or relating to this promotion are governed by, and construed in accordance with, the laws of Florida, without giving effect to any of its conflict of laws provisions thereof. Entrant further agrees that any legal suit, action, or proceeding arising out of or relating to this promotion shall be brought exclusively in the applicable federal or state courts located in Miami-Dade, Florida. This promotion is subject to and governed by the Terms of Service and Privacy Policy.
`
    },
    {
        id: 'hardest-working',
        title: "Hardest Working Comic",
        content: `
### 1. HOW TO ENTER
Beginning on January 1st, 2026 through December 15, 2026 (the “Promotion Period”), log-in to the Comedy Seen app using your Comedian account, and begin adding and/or checking-in to open mics and showcases.

### 2. ELIGIBILITY
Open to residents of states and countries where the app is available and 18 years of age and older as of January 1st, 2026. Void in countries where the app is not available and where otherwise prohibited.

### 3. LIMITATION OF LIABILITY
By entering this promotion, entrants waive all right to, and hold Pobblebonk, LLC harmless from, any claim, liability, loss, damage (including punitive, incidental, and consequential damages), or expense (including attorneys' fees) arising out of or in connection with participation in this promotion or the acceptance, use, or misuse of any prize.

### 4. WINNER SELECTION
Winners will be determined as follows:

* (a) Each registered check-in during the Promotion Period by an individual Comedian will be counted as one point.
* (b) Each registered check-in during the Promotion Period by an individual Comedian that is verified by either a Fan or Comedian will count as one point.
* (c) Pobblebonk, LLC reserves the right to disqualify any entrant found to be tampering with the entry process, using automated scripts/bots, or violating the Term of Service.

### 5. PRIZES
**Winner:** Comedian with the most points collected during the Promotion Period will receive $100.

### 6. CHOICE OF LAW, FORUM, TERMS, AND PRIVACY
Entrant agrees that all matters arising out of or relating to this promotion are governed by, and construed in accordance with, the laws of Florida, without giving effect to any of its conflict of laws provisions thereof. Entrant further agrees that any legal suit, action, or proceeding arising out of or relating to this promotion shall be brought exclusively in the applicable federal or state courts located in Miami-Dade, Florida. This promotion is subject to and governed by the Terms of Service and Privacy Policy.
`
    },
    {
        id: 'top-host',
        title: "Top Open Mic/Host",
        content: `
### 1. HOW TO ENTER
Beginning on January 1st, 2026 through December 15, 2026 (the “Promotion Period”), log-in to the Comedy Seen app using your Comedian account, and submit or claim your open mic.

### 2. ELIGIBILITY
Open to residents of states and countries where the app is available and 18 years of age and older as of January 1st, 2026. Void in countries where the app is not available and where otherwise prohibited.

### 3. LIMITATION OF LIABILITY
By entering this promotion, entrants waive all right to, and hold Pobblebonk, LLC harmless from, any claim, liability, loss, damage (including punitive, incidental, and consequential damages), or expense (including attorneys' fees) arising out of or in connection with participation in this promotion or the acceptance, use, or misuse of any prize.

### 4. WINNER SELECTION
Winners will be determined as follows:

* (a) Each registered check-in during the Promotion Period at the open mic will count as one point.
* (b) In the event of a tie, the winning mic will be determined by lifetime points accumulated on the app first, and duration of the mic in the Comedy Seen database second.
* (c) Pobblebonk, LLC reserves the right to disqualify any entrant found to be tampering with the entry process, using automated scripts/bots, or violating the Term of Service.

### 5. PRIZES
* **1st Place:** $150.00 cash prize
* **2nd Place:** $100.00 cash prize
* **3rd Place:** $50.00 cash prize

Prizes will be given to the registered host who was the host when the most points were accumulated. If there is no registered host then the prize will go to the contact person associated with the mic. All prizes are subject to be increased at the discretion of the founder of Pobblebonk, LLC.

### 6. CHOICE OF LAW, FORUM, TERMS, AND PRIVACY
Entrant agrees that all matters arising out of or relating to this promotion are governed by, and construed in accordance with, the laws of Florida, without giving effect to any of its conflict of laws provisions thereof. Entrant further agrees that any legal suit, action, or proceeding arising out of or relating to this promotion shall be brought exclusively in the applicable federal or state courts located in Miami-Dade, Florida. This promotion is subject to and governed by the Terms of Service and Privacy Policy.
`
    },
    {
        id: 'top-fan',
        title: "Top Fan",
        content: `
### 1. HOW TO ENTER
Beginning on January 1st, 2026 through December 15, 2026 (the “Promotion Period”), log-in to the Comedy Seen app using your Fan account, and begin checking-in to open-mics and showcases.

### 2. ELIGIBILITY
Open to residents of states and countries where the app is available and 18 years of age and older as of January 1st, 2026. Void in countries where the app is not available and where otherwise prohibited. Users who are known as only producers will be excluded from eligibility.

### 3. LIMITATION OF LIABILITY
By entering this promotion, entrants waive all right to, and hold Pobblebonk, LLC harmless from, any claim, liability, loss, damage (including punitive, incidental, and consequential damages), or expense (including attorneys' fees) arising out of or in connection with participation in this promotion or the acceptance, use, or misuse of any prize.

### 4. WINNER SELECTION
Winners will be determined by "Total Fan Points" as follows:

* (a) Each showcase ticket purchased through Comedy Seen will be counted as one point.
* (b) Each post show feedback including verification and upvoting will be counted as one point.
* (c) Each registered check-in to an open mic will count as ten points.
* (d) Each validated showcase that is submitted will be counted as one Point.
* (e) Each validated Open Mic that is submitted will be counted as two Points.
* (f) Each validated dead Open Mic an individual fan reports as being dead will be counted as three Points.
* (g) Each valid and unique bug report will be counted as ten points.
* (h) In the event of a tie, the winner will be determined by lifetime points accumulated on the app first, and duration of their account second.
* (i) Pobblebonk, LLC reserves the right to disqualify any entrant found to be tampering with the entry process, using automated scripts/bots, or violating the Term of Service.

### 5. PRIZES
Top three winners will win a pair of tickets to see any live stand up comedy show of the winners choosing (max face value ticket price excluding fees of $70 face value /ticket). Method of distribution will be worked out with the winners and Comedy Seen.

All prizes are subject to change at the discretion of the founder of Pobblebonk, LLC.

### 6. CHOICE OF LAW, FORUM, TERMS, AND PRIVACY
Entrant agrees that all matters arising out of or relating to this promotion are governed by, and construed in accordance with, the laws of Florida, without giving effect to any of its conflict of laws provisions thereof. Entrant further agrees that any legal suit, action, or proceeding arising out of or relating to this promotion shall be brought exclusively in the applicable federal or state courts located in Miami-Dade, Florida. This promotion is subject to and governed by the Terms of Service and Privacy Policy.
`
    },
    {
        id: 'top-producer',
        title: "Top Producer",
        content: `
### 1. HOW TO ENTER
Beginning on January 1st, 2026 through December 15, 2026 (the “Promotion Period”), log-in to the Comedy Seen app using your Fan or Comedian account, and begin checking-in to open-mics and showcases.

### 2. ELIGIBILITY
Open to residents of states and countries where the app is available and 18 years of age and older as of January 1st, 2026. Void in countries where the app is not available and where otherwise prohibited.

### 3. LIMITATION OF LIABILITY
By entering this promotion, entrants waive all right to, and hold Pobblebonk, LLC harmless from, any claim, liability, loss, damage (including punitive, incidental, and consequential damages), or expense (including attorneys' fees) arising out of or in connection with participation in this promotion or the acceptance, use, or misuse of any prize.

### 4. WINNER SELECTION
Winners will be determined by "Total Producer Points" as follows:

* (a) Each validated showcase that is submitted (including festival showcases) will be counted as one Point.
* (b) In the event of a tie, the winner will be determined by lifetime showcases contributed on the app first, and duration of their account second.
* (c) Pobblebonk, LLC reserves the right to disqualify any entrant found to be tampering with the entry process, using automated scripts/bots, or violating the Term of Service.

### 5. PRIZES
* **1st Place:** 2 Comedy Seen shows in the 2027 promotion period that Comedy Seen will cover half of your marketing spend (maximum $100 per show)
* **2nd Place:** 1 Comedy Seen show in the 2027 promotion period that Comedy Seen will cover half of your marketing spend (maximum $100 per show)
* **3rd Place:** 1 Comedy Seen show in the 2027 promotion period that Comedy Seen will cover half of your marketing spend (maximum $100 per show)

All prizes are subject to be increased at the discretion of the founder of Pobblebonk, LLC.

### 6. CHOICE OF LAW, FORUM, TERMS, AND PRIVACY
Entrant agrees that all matters arising out of or relating to this promotion are governed by, and construed in accordance with, the laws of Florida, without giving effect to any of its conflict of laws provisions thereof. Entrant further agrees that any legal suit, action, or proceeding arising out of or relating to this promotion shall be brought exclusively in the applicable federal or state courts located in Miami-Dade, Florida. This promotion is subject to and governed by the Terms of Service and Privacy Policy.
`
    }
];

const taxRules = {
    title: "GENERAL TAX CONDITIONS",
    content: `
**APPLICABLE TO ALL PROMOTIONS**

**Cumulative Winnings & IRS Reporting:** All prize awards are subject to verification of eligibility and compliance with these Official Rules. The value of prizes won may be taxable as income.

In accordance with IRS regulations, if the cumulative value of all prizes won by a single Entrant across all Pobblebonk, LLC promotions (including Top Comic, Hardest Working Comic, Top Fan, etc.) equals or exceeds $2,000.00 USD within a single calendar year, the winner will be required to complete and submit an IRS Form W-9 providing their Social Security Number or Tax ID. Pobblebonk, LLC will issue an IRS Form 1099-NEC to the winner for the total value of all prizes received during the year. Failure to provide a valid W-9 upon request may result in the forfeiture of prizes.
`
};

function Promotion26() {
    const links = [
        { "link": "/About", "label": "About" },
        { "link": "/Support", "label": "Support" },
        { "link": "/Pp", "label": "Privacy" },
        { "link": "/Tos", "label": "Terms of Use" },
    ];

    return (
        <div className="rules-wrapper">
            <Head />

            <Space h="xl" />

            {/* Main Page Title */}
            <Title ta="center" size="h1">2026 Official Rules</Title>
            <br />
            <br />
            <br />

            <Container size="md" py="xl">
                
                {/* Loop through the Contest Sections */}
                {rulesSections.map((section) => (
                    <Card key={section.id} shadow="sm" padding="lg" radius="md" withBorder mb="xl">
                        
                        <Title order={2} ta='center' mb="md" style={{ textDecoration: 'underline' }}>
                            {section.title}
                        </Title>

                        {/* Markdown Renderer for Rules */}
                        <div style={{ fontSize: '1rem', lineHeight: '1.6', fontFamily: 'sans-serif' }}>
                            <ReactMarkdown>
                                {section.content}
                            </ReactMarkdown>
                        </div>

                    </Card>
                ))}

                {/* Separate Card for Tax Rules to ensure it stands out */}
                <Card shadow="sm" padding="lg" radius="md" withBorder mb="xl" style={{ borderColor: '#e03131' }}>
                    <Title order={3} ta='center' mb="xs" c="red">
                        {taxRules.title}
                    </Title>
                    <Divider my="sm" />
                    <div style={{ fontSize: '0.95rem', lineHeight: '1.6', fontFamily: 'sans-serif' }}>
                        <ReactMarkdown>
                            {taxRules.content}
                        </ReactMarkdown>
                    </div>
                </Card>

            </Container>

            <Footer links={links} />
        </div>
    )
}

export default Promotion26;